import { Box, type SxProps, type Theme, useTheme } from "@mui/material";
import parse from "html-react-parser";
import type { FC, Ref } from "react";
import {
	adjustColorsForDarkMode,
	sanitizeHtml,
} from "web_myplann/Shared/Utils/htmlContentUtils";

type Props = {
	html: string;
	sx?: SxProps<Theme>;
	ref?: Ref<HTMLDivElement>;
};

export const MyPlannHtmlContent: FC<Props> = ({ html, sx, ref }) => {
	const theme = useTheme();

	const safeHtml = adjustColorsForDarkMode(
		sanitizeHtml(html),
		theme.palette.mode === "dark",
	);

	return (
		<Box ref={ref} sx={sx}>
			{parse(safeHtml)}
		</Box>
	);
};
